import { Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { NotificationSettingInterface } from '@shared/api';
import { Observable, switchMap, take } from 'rxjs';
import { CustomEntityCollectionBaseService } from '../../entity-collection-base.class';
import { EntityTypeEnum } from '../../entity.interface';

@Injectable({
  providedIn: 'root',
})
export class NotificationSettingsService extends CustomEntityCollectionBaseService<NotificationSettingInterface> {
  constructor(elementsFactory: EntityCollectionServiceElementsFactory) {
    super(EntityTypeEnum.NotificationSetting, elementsFactory);
  }

  toggleTelegramItem(
    setting: NotificationSettingInterface,
  ): Observable<NotificationSettingInterface> {
    return this.update(
      {
        ...setting,
        telegram: !setting.telegram,
      },
      { isOptimistic: true },
    );
  }

  toggleAllTelegramItems(): Observable<NotificationSettingInterface> {
    return this.entities$.pipe(
      take(1),
      switchMap((settings) =>
        this.update(
          {
            email: true,
            telegram: !settings.every((setting) => setting.telegram),
          },
          { isOptimistic: true },
          settings.map((setting) => setting.id),
        ),
      ),
    );
  }
}
